export default class Authors
{


    constructor()
    {
        this.bindEvents();
    }

    bindEvents()
    {
        this.fctLoadAuthors = this.loadAuthors.bind(this);
        this.selectAuthor = document.querySelector( '#author' );

        $(this.selectAuthor).on( 'change', this.fctLoadAuthors);
    }

    loadAuthors (event)
    {
        let url = event.currentTarget.value;
        window.location = url;
    }
}
